import Divider from "../components/constants/ui/Divider";
import Heading from "../components/constants/ui/Heading";
import Masonry from "../components/Masonry";
import { useState, useEffect } from "react";
import GlobalApi from "../utils/GlobalApi";
import { type Media } from "../utils/types";
import SEO from "../components/SEO";
import { optimizeImage } from "../utils/imageUrl";

const BookPage = () => {
    const [items, setItems] = useState<Media[]>([]);

    useEffect(() => {
        GlobalApi.getMedia().then((data) => {
            console.log(data);
            setItems(data.books[0].images);
        });
    }, []);

    function formatHeight(height: number) {
        if (height > 1300) {
            return height / 5;
        }
        return height / 1.5;
    }

    return (
      <div className="min-h-screen bg-black p-4 md:p-20 pt-25 md:pt-30">
        <SEO
          title="Book fotografico — Alessandro Scafati, attore"
          description="Book fotografico di Alessandro Scafati: portfolio immagini per casting di cinema, televisione e teatro."
          path="/book"
        />
        <Heading title="Book" />
        <Divider className="mb-4" />
        <Masonry
          items={items.map((item) => ({
            id: item.id,
            url: optimizeImage(item.url, 1600),
            img: optimizeImage(item.url, 600),
            height: formatHeight(item.height),
          }))}
          ease="power3.out"
          duration={0.6}
          stagger={0.05}
          animateFrom="bottom"
          scaleOnHover={true}
          hoverScale={0.95}
          blurToFocus={true}
          colorShiftOnHover={false}
        />
      </div>
    );
};
  
export default BookPage;